export default "__VITE_ASSET__DAIKkrcb__"